const { connect } = require('react-redux');
const { context } = require('app-context');
const PreapprovedEmailUpload = require('../components/PreapprovedEmailUpload');

const api = context.api.nearpeer;
const selectors = context.selectors.all;
const actions   = context.actions;

module.exports = connect(
    (state) => ({
        schoolId: selectors.getCurrentSchoolId(state),
        schoolName: selectors.getCurrentSchoolName(state),
        schoolRoles: selectors.getSchoolRoles(state)
            .filter(({ name }) => name !== 'superuser' && name !== 'observer'),
        api
    }), {
        onSubmit: actions.communication.uploadPreapproved,
        showToast: actions.alerts.notification.push
    }
)(PreapprovedEmailUpload);
